import AuthRoute from './AuthRoute';
import CreatePassword from './CreatePassword';
import Field from '@rezdy/components/Form/Field';
import Password from '@rezdy/components/Password';
import TextStyle from '@rezdy/components/TextStyle';
import { H4 } from '@rezdy/components/Heading';
import React from 'react';
import routes from '../constants/routes';
import routing from '../services/routing';
import { withTranslation } from 'react-i18next';

class ChangePassword extends AuthRoute {
    renderHeader = () => {
        const { context, i18n } = this.props;
        return (
            <TextStyle align="center">
                <H4>{i18n.t('header', { context })}</H4>
                <TextStyle as="p">{i18n.t('subHeader', { context })}</TextStyle>
            </TextStyle>
        );
    };

    onSubmit = (formData: any) => {
        const { action, i18n } = this.props;
        const { isLoading } = this.state;

        if (!isLoading) {
            this.setState({ isLoading: true }, async () => {
                try {
                    await action(formData);
                    this.setState({
                        data: {},
                        isDirty: false,
                        isLoading: false,
                        message: i18n.t('password', { context: 'changed' }),
                    });
                } catch (error) {
                    this.setState({
                        isDirty: true,
                        isLoading: false,
                        message: error.message,
                    });
                }
            });
        }
    };

    onSecondaryClick = () => {
        routing.push(routes.PROFILE);
    };

    renderBody = () => {
        const { i18n } = this.props;
        return (
            <React.Fragment>
                <Field label={i18n.t('password', { context: 'current' })} name="oldPassword">
                    <Password />
                </Field>
                <CreatePassword label={i18n.t('password', { context: 'new' })} name="newPassword" />
            </React.Fragment>
        );
    };
}

export default withTranslation()(ChangePassword);
